import { render, staticRenderFns } from "./FilterSort.vue?vue&type=template&id=14dd8966&scoped=true"
import script from "./FilterSort.vue?vue&type=script&lang=js"
export * from "./FilterSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd8966",
  null
  
)

export default component.exports